import { Component, EventEmitter, Input, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-modal-edit-gas-meter-read',
  template: `
    <ng-template #modalEditGasMeterRead let-modal>
      <div class="modal-header">
        <h5 class="modal-title">Editar Lectura de Gas</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()"></button>
      </div>
      <div class="modal-body">
        <div class="d-flex">
          <div class="me-2" *ngIf="gasMeterRead?.photo">
            <img [src]="gasMeterRead.photo" width="100px" class="rounded-3 shadow-sm">
          </div>
          <div class="flex-fill">
            <table class="table table-sm">
              <tbody>
                <tr>
                  <th>Lectura Anterior</th>
                  <td class="text-end" *ngIf="gasMeterRead?.value_prev">{{gasMeterRead?.value_prev}}</td>
                  <td class="text-end" *ngIf="!gasMeterRead?.value_prev">-</td>
                </tr>
                <tr>
                  <th>Consumo M<sup>3</sup></th>
                  <td class="text-end" *ngIf="gasMeterRead?.consumo_m3">{{gasMeterRead?.consumo_m3 | number: '1.2-2'}} M<sup>3</sup></td>
                  <td class="text-end" *ngIf="!gasMeterRead?.consumo_m3">-- M<sup>3</sup></td>
                </tr>
                <tr>
                  <th>Consumo Lts.</th>
                  <td class="text-end" *ngIf="gasMeterRead?.consumo_lt">{{gasMeterRead?.consumo_lt | number: '1.2-2'}} Lts.</td>
                  <td class="text-end" *ngIf="!gasMeterRead?.consumo_lt">-- Lts.</td>
                </tr>
                <tr>
                  <th>Actual</th>
                  <td class="text-end" *ngIf="gmr['value'].value">{{gmr['value'].value}}</td>
                  <td class="text-end" *ngIf="!gasMeterRead?.value">-</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <form [formGroup]="gasMeterReadForm" (ngSubmit)="onSubmit()">
          <div class="mb-3">
            <label for="value" class="form-label">Lectura</label>
            <input type="text" id="value" formControlName="value" class="form-control" required> 
          </div>
          <div class="mb-3 text-end">
            <button type="submit" 
              class="btn btn-zazz-dark"
            >Actualizar</button>
          </div>
        </form>
      </div>
    </ng-template>
  `,
  styles: ``
})
export class ModalEditGasMeterReadComponent {
  @Input() gasMeterRead: any;
  @Output() onGasMeterReadUpdated = new EventEmitter<any>();
  @ViewChild('modalEditGasMeterRead') modalEditGasMeterRead!: any;

  gasMeterReadForm: FormGroup = new FormGroup({});

  private modalRef: NgbModalRef | undefined;

  constructor(
    private modalService: NgbModal,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['gasMeterRead'] && changes['gasMeterRead'].currentValue) {
      this.gasMeterReadForm.patchValue(changes['gasMeterRead'].currentValue);
    }
  }

  ngOnInit() {
    this.gasMeterReadForm = this.fb.group({
      id: [this.gasMeterRead?.id || ''],
      value: [this.gasMeterRead?.value || ''],
      photo: [this.gasMeterRead?.photo || ''],
      consumo_m3: [this.gasMeterRead?.consumo_m3 || 0],
      consumo_lt: [this.gasMeterRead?.consumo_lt || 0],
      gas_price: [this.gasMeterRead?.gas_price || 0],
      unit_id: [this.gasMeterRead?.unit_id || ''],
      gas_meter_id: [this.gasMeterRead?.gas_meter_id || ''],
      bill_item_id: [this.gasMeterRead?.bill_item_id || '']
    });
  }

  get gmr() {
    return this.gasMeterReadForm.controls;
  }

  onSubmit() {
    // if (this.gasMeterReadForm.valid) {
      const updatedRead = this.gasMeterReadForm.value;
      this.onGasMeterReadUpdated.emit(updatedRead);
      this.dismiss();
    // } 
  }

  openModal(modalContent: TemplateRef<any>) {
     this.modalRef = this.modalService.open(modalContent);
    if (!this.gasMeterRead) {
      console.warn('ModalEditGasMeterReadComponent: No gasMeterRead was provided when opening modal');
    }
    this.modalRef = this.modalService.open(this.modalEditGasMeterRead);
  }

  dismiss() {
    if (this.modalRef) {
      this.modalRef.dismiss();
      this.gasMeterReadForm.reset();
    }
  }
}
